<template>
    <div class="container">
        <div class="w-full mt-10 lg:mt-16 px-5 lg:px-0 flex flex-wrap justify-center">
            <router-link tag="button"
                :key="category"
                class="category text-black py-1 px-8 border border-solid border-black mx-2 mt-4 rounded-3xl"
                :class="{ active : activeCategory === category }"
                v-for="category in categories"
                :to="{ name: 'videos', params: { category }}"
            >
                {{ category }}
            </router-link>
            <button
                @click="activeCategory = category"
                >

            </button>
        </div>
        <div class="bg-white px-5 md:px-10 lg:px-0 py-16 lg:py-12">
            <transition-group tag="div" name="fade">
                <div class="grid gap-x-10 gap-y-12" v-for="category in categories" v-show="activeCategory === category" :key="category">
                    <div class="video" v-for="video in videosByCategory[category]" :key="video.id">
                        <div class="iframe-container">
                            <iframe allowfullscreen :src="video.source"></iframe>
                        </div>
                        <p class="date mt-2 mb-1">{{ video.date }}</p>
                        <p class="title font-bold">{{ video.title }}</p>
                    </div>
                </div>
            </transition-group>
        </div>
    </div>
</template>

<script>
const updateMetaTags = category => {
    document.title = category.meta_title[window.appLocale] || 'Vídeos';
    document.querySelector('meta[name=description]').attr('content', category.meta_description[window.appLocale]);
    document.querySelector('meta[name=keywords]').attr('content', category.meta_keywords[window.appLocale]);
};
const updateLangLinks = category => {
    const langs = ['ca', 'es'];

    for (let lang of langs) {
        const $link = $(`.lang-container a[hreflang=${lang}]`);
        const arr = $link.attr('href').split('/');
        arr.pop();
        if (! arr.includes('videos')) {
            arr.push('videos');
        }
        arr.push(category.name[lang]);
        $link.attr('href', arr.join('/'));
    }
};

export default {
    props: ['videosByCategory', 'initialCategories', 'activeCategoryId'],

    data() {
        return {
            categories: [],
            activeCategory: '',
        }
    },

    created() {
        this.categories = Object.keys(this.videosByCategory);
        this.activeCategory = this.categories[0];
    },

    methods: {
        reload(to, from, next) {
            this.activeCategory = to.params.category;
            const category = this.initialCategories.find(c => c.name[window.appLocale] === this.activeCategory);
            updateMetaTags(category);
            updateLangLinks(category);
            next();
        }
    },

    beforeRouteEnter (to, from, next) {
        next(vm => {
            if (vm.activeCategoryId) {
                const category = vm.initialCategories.find(c => c.id == vm.activeCategoryId);
                vm.activeCategory = category.name[window.appLocale];
                updateMetaTags(category);
                updateLangLinks(category);
            }
        });
    },

    beforeRouteUpdate (to, from, next) {
        this.reload(to, from, next);
    },

    beforeRouteLeave (to, from, next) {
        this.reload(to, from, next);
    }
};
</script>

<style scoped>
.fade-enter-active {
    transition: opacity .7s;
}
.fade-enter, .fade-leave-to {
    opacity: 0;
}
</style>
